import { default as Form } from "./Form"

const Training = { Form }

export default Training
